window.Promise = require('bluebird')

import Vue from 'vue'
import App from './App'

// store
import store from './store'

// configs
import { router } from './config/router'
import i18n from './config/locale'
import './config/axios'
import './config/auth'
import './config/multiselect'
import './config/utils'

// plugins
import Buefy from 'buefy'
import Vuelidate from 'vuelidate'
import moment from 'moment'
import 'moment/locale/fr'
import VueMoment from 'vue-moment'
import { VueLLazyload } from 'vue-l-lazyload'
import VueScrollTo from 'vue-scrollto'

Vue.use(Buefy)
Vue.use(Vuelidate)
Vue.use(VueMoment, { moment })
Vue.use(VueScrollTo, { offset: -60 })
Vue.use(VueLLazyload, { classTarget: 'parent' })

Vue.config.productionTip = false

initAnalytics()

// global mixins
Vue.mixin({
  computed: {
    user() {
      return this.$auth.user()
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  store,
  created() {
    window.Promise.onPossiblyUnhandledRejection(this.$handleErrors)
  },
  render: h => h(App)
})

/* eslint-disable */
function initAnalytics() {
  if (process.env.NODE_ENV !== 'production') {
    return
  }

  window.dataLayer = window.dataLayer || [];
  window.gtag = function (){dataLayer.push(arguments);};
  gtag('js', new Date());
  gtag('config', 'UA-97717342-1', {
    'send_page_view': false 
  });
}



// WEBPACK FOOTER //
// ./src/main.js